import React from 'react';
import { FileEdit, Loader2, RefreshCw, Clock, Trash2 } from 'lucide-react';

const DraftRow = ({ draft, isActive, onLoad, onDelete }) => {
  const displayName = (draft.first_name || draft.last_name)
    ? `${draft.first_name || ''} ${draft.last_name || ''}`.trim()
    : 'Unnamed Draft';

  return (
    <div
      onClick={() => onLoad(draft)}
      className={`flex items-center justify-between p-3 rounded-lg cursor-pointer transition-colors ${
        isActive
          ? 'bg-yellow-500/20 border border-yellow-500/30'
          : 'bg-[#1a1a1f] hover:bg-[#252530] border border-gray-700'
      }`}
      data-testid={`draft-row-${draft.id}`}
    >
      <div className="flex-1 min-w-0">
        <p className="text-white text-sm font-medium truncate">{displayName}</p>
        <div className="flex items-center gap-2 text-gray-500 text-xs mt-0.5">
          <Clock className="w-3 h-3" />
          {new Date(draft.updated_at).toLocaleString()}
          {draft.transferred_by_agent && (
            <span className="text-teal-400">• {draft.transferred_by_agent}</span>
          )}
        </div>
      </div>
      <button
        onClick={(e) => onDelete(draft.id, e)}
        className="p-1.5 text-gray-500 hover:text-red-400 hover:bg-red-500/10 rounded transition-colors"
        title="Delete draft"
        data-testid={`draft-delete-${draft.id}`}
      >
        <Trash2 className="w-4 h-4" />
      </button>
    </div>
  );
};

export const DraftsPanel = ({ drafts, loading, currentDraftId, onRefresh, onLoad, onDelete }) => (
  <div className="border-b border-gray-800 bg-[#0a0a0f] p-4" data-testid="drafts-panel">
    <div className="flex items-center justify-between mb-3">
      <h3 className="text-white font-medium flex items-center gap-2">
        <FileEdit className="w-4 h-4 text-yellow-400" />
        Saved Drafts
      </h3>
      <button
        onClick={onRefresh}
        disabled={loading}
        className="text-gray-400 hover:text-white p-1"
        data-testid="drafts-refresh-btn"
      >
        <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
      </button>
    </div>
    {loading ? (
      <div className="flex items-center justify-center py-4">
        <Loader2 className="w-5 h-5 text-gray-400 animate-spin" />
      </div>
    ) : drafts.length === 0 ? (
      <p className="text-gray-500 text-sm text-center py-4">No drafts saved</p>
    ) : (
      <div className="space-y-2 max-h-48 overflow-y-auto">
        {drafts.map((draft) => (
          <DraftRow
            key={draft.id}
            draft={draft}
            isActive={currentDraftId === draft.id}
            onLoad={onLoad}
            onDelete={onDelete}
          />
        ))}
      </div>
    )}
  </div>
);
